
const SpinLoader = ({ classNamecolor }) => {
  return (
    <div className="flex items-center justify-center ">
      <div className={`w-4 h-4 border-2 border-t-transparent ${classNamecolor === 'true' ? 'border-black w-12 h-12' : 'border-white'}  rounded-full animate-spin`}></div>
    </div>
  );
};

export default SpinLoader;
